<template>
  <b-container>
    <b-row>
      <b-col class="link-col" cols="3">
        <!-- <router-link //TODO: implement side bar
          class="nav-item"
          :class="{ currentNavItem: currentRoute == 'Team' }"
          to="/team"
          @click.native="closeMenu"
          >General</router-link
        >
        <router-link
          class="nav-item"
          :class="{ currentNavItem: currentRoute == 'Team' }"
          to="/team"
          @click.native="closeMenu"
          >Lenders</router-link
        >
        <router-link
          class="nav-item"
          :class="{ currentNavItem: currentRoute == 'Team' }"
          to="/team"
          @click.native="closeMenu"
          >Other</router-link
        > -->
      </b-col>
      <b-col class="faq-col" cols="9">
        <div v-for="faq_section in faqs" :key="faq_section.section_index">
          <p class="faq-title">{{ faq_section.section_title }}</p>
          <div
            v-for="faq in faq_section.section_questions"
            :key="faq.index"
            class="faq-section"
          >
            <p class="faq-header">Question</p>
            <p class="faq-question">{{ faq.question }}</p>
            <p class="faq-header">Answer</p>
            <p class="faq-answer">{{ faq.answer }}</p>
          </div>
        </div>
        <div id="contact-us">

          <p class="faq-title large-spacer">Send Support Ticket</p>

          <p class="error-message" v-if="error">{{ error }}</p>
          <p class="success-message" v-if="success">{{ success }}</p>

          <label class="ticket-form-label" for="contact-email"
            >What email should we respond to?</label
          >
          <b-form-input
            class="ticket-form-input"
            id="contact-email"
            type="email"
            v-model="email"
            placeholder="Email"
          ></b-form-input>
          <label class="ticket-form-label" for="contact-subject"
            >Leave a short summary of your issue</label
          >
          <b-form-input
            class="ticket-form-input"
            id="contact-subject"
            type="text"
            v-model="subject"
            placeholder="Subject"
          ></b-form-input>
          <label class="ticket-form-label" for="contact-body"
            >Leave a detailed description of what we can help with</label
          >
          <b-form-textarea
            class="ticket-form-input"
            id="contact-body"
            v-model="body"
            placeholder="Details"
            rows="3"
            max-rows="8"
          ></b-form-textarea>

          <button class="submit-button" @click="submitFAQ">Submit Question</button>
        </div>
       
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { SECTIONS } from './support-text';
import { db } from '../../firebase';
import {v4 as uuidv4} from 'uuid'
import { EventBus } from '../../tools/event-bus';

export default {

  //potentially useful if we can navigate how to activate the event after the page loads

  // beforeRouteEnter(to, from, next) {
  //   EventBus.$once('scroll-to-contact', () => {
  //     next(vm => {
  //       vm.scrollToContact();
  //     });
  //   });
  //   next()
  // },

  
  mounted(){
    this.setupEventListeners()
  },
  data() {
    return {
      isOpen: false,
      faqs: [],
      email: '',
      subject: '',
      body: '',
      error: '',
      success: ''

    };
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    }
  },
  methods: {
    createFaqs() {
      for (let i = 0; i < SECTIONS.length; i++) {
        this.faqs.push({
          section_index: i,
          section_questions: [],
          section_answers: [],
          section_title: SECTIONS[i].title
        });
        for (let r = 0; r < SECTIONS[i].questions.length; r++) {
          let cur_faq = this.faqs[i];
          cur_faq.section_questions.push({
            index: r,
            question: SECTIONS[i].questions[r],
            answer: SECTIONS[i].answers[r]
          });
        }
      }
    },

    setupEventListeners() {
      EventBus.$on('scroll-to-contact', this.scrollToContact)
    },

    async submitFAQ(){
      const id = uuidv4()
      if (this.email && this.body && this.subject) {
        this.error = ''
        db.collection('support-tickets')
          .add({ 
            id,
            email: this.email,
            subject: this.subject,
            body: this.body 
          }).catch(() => this.error = 'There was a problem submitting your request, please try again later.')
          this.success = 'Successfully submitted your request! We will get back to you shortly.'
        } else {
          this.success = ''
          if (!this.email) {
            this.error = 'Email is required.';
          } 
          else if (!this.subject) {
            this.error = 'Subject is required.';
          }
          else if (!this.body) {
            this.error = 'Body is required.';
          } 
      }
    },

    scrollToContact(){
      const target = document.getElementById('contact-us')
      if(target){
        target.scrollIntoView({behavior: 'smooth'})
      }
    },

    beforeDestroy() {
      EventBus.$off('scroll-to-contact', this.scrollToContact)
    }
  
  },
  beforeMount() {
    this.createFaqs();
  }
};
</script>

<style scoped>
.nav-item {
  color: rgb(12, 192, 150) !important;
  font-size: 32px;
  /* flex-grow: 1; */
  text-align: left;
  padding: 10px;
  margin-bottom: 50px;
}
.nav-item:hover {
  color: rgb(0, 160, 125) !important;
}

.faq-section {
  background-color: rgb(240, 240, 240);
  border: 1px solid rgb(225, 225, 225);
  -moz-box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.2);
  margin-bottom: 1rem;
  padding: 1rem;
}

.faq-title {
  font-size: 42px;
  color: rgb(12, 192, 150);
  font-weight: bold;
  text-align: left;
  margin-top: 2rem;
  margin-left: -20px;
}

.link-col {
  display: flex;
  flex-direction: column;
  margin-top: 80px;
  position: fixed;
  width: 200px;
}

.faq-header {
  color: black;
  font-size: 32px;
  font-weight: bold;
  text-align: left;
}

.faq-answer {
  font-size: 18px;
  color: black;
  text-align: left;
}

.faq-question {
  font-size: 18px;
  color: black;
  text-align: left;
}

.faq-col {
  margin-left: 150px;
}

.ticket-form-label {
  display: flex;
  color: black;
  font-size: 32px;
  font-weight: bold;
  text-align: left;
}

.ticket-form-input {
  background-color: rgb(240, 240, 240);
  margin-bottom: 1rem;
}

.large-spacer {
  margin-top: 3rem;
}

.submit-button {
  background-color: rgb(12, 192, 150);
  color: white;
  width: 150px; /* Adjust width as needed */
  padding: 10px 20px;
  border-radius: 8px;
  margin-bottom: 10px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out; 
}

.submit-button:hover {
  background-color: rgba(12, 192, 150, 0.8); 
}

.error-message {
  color: red; 
  background-color: rgba(255, 0, 0, 0.1); 
  padding: 10px;
  border-radius: 4px;
  margin-top: 10px;
}

.success-message {
  color: green; 
  background-color: rgba(0, 255, 0, 0.1); 
  padding: 10px;
  border-radius: 4px;
  margin-top: 10px;
}

</style>
